import React from "react";
import { Optional } from "sprint-common-web/src/utils/types/Optional";

import { CloudVideoAssetItem } from "../../../../../../../common/api/master-api/assets/get-cloud-video-assets/GetCloudVideoAssetsResponse";
import { GetCloudFilePreviewRequest } from "../../../../../../../common/api/master-api/cloud-files/get-preview/GetCloudFilePreviewRequest";
import { CloudFileDetails } from "../../../../CloudFileDetails";
import { CloudFilePreviewItem } from "../types/CloudFilePreviewItem";

export interface CloudFilePreviewContext {
    isDvb: boolean;
    isZip: boolean;
    isPreviewAvailable: boolean;
    reloadWithConformingVideo: boolean;
    filePreview: Optional<CloudFilePreviewItem>;
    isPreviewLoading: boolean;
    reloadPreview(request: GetCloudFilePreviewRequest): Promise<void>;
    isCloudFileDetailsLoading: boolean;
    cloudFileDetails: CloudFileDetails;
    availableVideoFiles: CloudVideoAssetItem[];
    selectedVideoCloudFileId: Optional<string>;
}

export const CloudFilePreviewContext = React.createContext<CloudFilePreviewContext>({} as CloudFilePreviewContext);
